if(document.getElementById('filter')) {
	var app = new Vue({
		el: '#filter',
		data: {
			translate: Global.list,
			casestudies: Global.casestudies,
			campaignTags: Global.tags.campaignTags.sort(),
			industryTags: Global.tags.industryTags.sort(),
			clientTags: Global.tags.clientTags.sort(),
			basePath: Global.basePath,
			activeCasestudies: [],
			activeOptions: [],
			base: 5,
			visibleItems: null,
			tags: {
				campaignTags: -1,
				industryTags: -1,
				clientTags: -1,
			},
		},
		template:
			`
		<div style="position:relative;">
			<div class="row">
				<div class="column" data-anim-fade="fadeIn" id="filters">
					<div class="filter__selects row" data-anim-up>		
						<div class="filter__select column">
							<label class="typo-b1" for="campaignTags">{{translate.filter.one}}</label>
							<div class="select campaignTags">
								<select @change="onChange" class="select__item" name="campaignTags" id="campaignTags" v-model="tags.campaignTags">
								 	  <option value="-1">{{translate.filter.choose}}</option>	
									  <option 
										   v-for="campaignTag in campaignTags" 
										   v-bind:value="campaignTag.id"
									  >
									  {{ campaignTag.value }}
									  </option>
								</select>
							</div>
						</div>
						<div class="filter__select column" v-if="activeOptions.industryTags">
							<label class="typo-b1" for="industryTags">{{translate.filter.two}}</label>
							<div class="select">
								<select @change="onChange" class="select__item" name="industryTags" id="industryTags" v-model="tags.industryTags">
									<option value="-1">{{translate.filter.choose}}</option>	
									  <option 
										   v-for="industryTag in industryTags"
										   v-if="activeOptions.industryTags.includes(industryTag.id)" 
										   v-bind:value="industryTag.id"
									  >
										{{industryTag.value}}
									</option>
								</select>
							</div>
						</div>
						<div class="filter__select column" v-if="activeOptions.clientTags">
							<label class="typo-b1" for="clientTags">{{translate.filter.three}}</label>
							<div class="select">
								<select @change="onChange" class="select__item" name="clientTags" id="clientTags" v-model="tags.clientTags">
									<option value="-1">{{translate.filter.choose}}</option>
									<option 
										   v-for="clientTag in clientTags" 
										   v-if="activeOptions.clientTags.includes(clientTag.id)"
										   v-bind:value="clientTag.id"
									  >
										{{clientTag.value}}
									</option>
								</select>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div id="filter-results" class="filter__results row" v-if="activeCasestudies.length">
				<div class="filter__column column" v-for="(casestudie, index) in activeCasestudies" v-if="index <= visibleItems">
					<a :href="casestudie.url" class="filter__casestudie-item">
						<div class="filter__casestudie-bg">
							<picture class="picture">
								<img :src="basePath + '/' + casestudie.coverImage" alt="">
							</picture>
						</div>
						<div class="filter__casestudie-content">
							<h3 v-html="casestudie.name"></h3>
							<h4 class="typo-b3" v-if="casestudie.brief" v-html="casestudie.brief.title"></h4>
							<div class="typo-b2">
								<br>
								<p v-if="casestudie.brief" v-html="casestudie.brief.perex"></p>
							</div>
						</div>
					</a>
				</div>
			</div>
			<div class="filter__load-more row">
				<div class="column text--center">
					<a href="#" @click.prevent="updateVisibleItems" v-if="visibleItems < activeCasestudies.length" class="filter__cta btn btn--secondary">
						<span class="btn__label">
							{{translate.filter.allJobs}}
						</span>
						<span class="btn__icon btn__icon--down"></span>
					</a>
				</div>
			</div>
			<div class="intro__scroll" data-anim-side="side">
				<p class="intro__scroll-label typo-d5 text--grey">{{translate.filter.label}}</p>
			</div>
		</div>
		`,
		methods: {
			updateVisibleItems() {
				this.visibleItems += 3;
			},
			onChange($event: Event | EventTarget | any) {

				let id = $event.target.id;

				if (id === 'campaignTags') {
					this.tags.industryTags = -1;
					this.tags.clientTags = -1;
				}

				this.activeCasestudies = this.filter(this.tags, true);
				this.activeOptions = this.filter(this.tags);
			},

			filter(newValues: any, returnCaseStudies: boolean = false) {

				const {campaignTags, clientTags, industryTags} = newValues;

				const filteredCaseStudies = this.casestudies.filter((caseStudy: any) => {
					const a = campaignTags > 0 ? caseStudy.campaignTags.indexOf(campaignTags) > -1 : true;
					const b = clientTags > 0 ? caseStudy.clientTags.indexOf(clientTags) > -1 : true;
					const c = industryTags > 0 ? caseStudy.industryTags.indexOf(industryTags) > -1 : true;

					return a && b && c;
				});

				if (returnCaseStudies) {
					return filteredCaseStudies;
				}

				return {
					industryTags: filteredCaseStudies.reduce(this.filterReducer('industryTags'), []),
					clientTags: filteredCaseStudies.reduce(this.filterReducer('clientTags'), [])
				};
			},


			filterReducer: (type: any) => (result: any, caseStudy: any) => {
				caseStudy[type].forEach((clientTag: any) => {
					if (result.indexOf(clientTag) === -1) {
						result.push(clientTag);
					}
				});

				return result;
			}


		},

		mounted() {
			this.visibleItems = this.base;
			this.activeCasestudies = this.filter(this.tags, true);
			this.activeOptions = this.filter(this.tags);


			let params = window.location.search
				.replace('?', '')
				.split('&')
				.map((param) => param.split('='))
				.map((param) => {
					const key = param[0];
					const value = param[1];
					return {[key]: value}
				})
				.reduce((stash, item) => {
					stash[Object.keys(item)[0]] = Object.keys(item).map((value) => item[value])[0];
					return stash;
				}, {});

			const found = Object.keys(params).some((r: any) => {
				return Object.keys(Global.tags).indexOf(r) > -1;
			});

			if (!found) {
				return false;
			}

			if(params.scrollTo) {
				TweenLite.to(window, 0.5, {
					scrollTo: {y: `#${params.scrollTo}`},
					autokill: false,
					ease: Power3.easeInOut
				});
			}

			Object.keys(this.tags).forEach((item)=>{
				params[item] ? this.tags[item] = +params[item] : false;
			});

			this.activeCasestudies = this.filter(this.tags, true);
			this.activeOptions = this.filter(this.tags);

		}
	});
}

